<template>
    <!-- Every read of `value` goes through count, and every emit sends a real
         number. The value can arrive as a STRING - a saved bedrooms_config comes
         from ACF, which returns number subfields as strings, and the input's own
         change event hands back a string whatever the type attribute says. With
         a string, `value + 1` CONCATENATES, and the parent's `v-model.number`
         then coerced the result back to a number - so the first press on a
         saved bed did this:

             0 -> "01" -> 1     correct, by accident
             1 -> "11" -> 11
             2 -> "21" -> 21
            12 -> "121" -> 121

         An empty bed behaving perfectly is exactly why this was never noticed.
         (`- 1` coerced and worked, and `:disabled="value <= 0"` compared
         correctly by coercion too, so only one of the two buttons was wrong.) -->
    <div class="flex items-center justify-between">
        <p
            class="label text-xsss 3xl:text-xs"
            v-html="props.label"
        ></p>

        <div class="flex gap-1.5">
            <button
                class="size-[36px] sm:size-[42px] shrink-0 border border-brand-2-950/10 not-disabled:hover:select-filter-active flex items-center justify-center rounded-full lh-transition"
                :class="{ 'opacity-50 cursor-not-allowed': count <= 0 }"
                :disabled="count <= 0"
                @click.prevent="$emit('update:value', Math.max(0, count - 1))"
            >
                <span
                    class="w-[10px]"
                    v-html="minusIcon"
                ></span>
            </button>

            <input
                class="input input-small max-w-[52px] text-center shrink-0"
                :name="count ? props.name : null"
                type="number"
                min="0"
                :value="count"
                @change="$emit('update:value', Math.max(0, Number($event.target.value) || 0))"
            />

            <button
                class="size-[36px] sm:size-[42px] shrink-0 border border-brand-2-950/10 not-disabled:hover:select-filter-active flex items-center justify-center rounded-full lh-transition"
                @click.prevent="$emit('update:value', count + 1)"
            >
                <span
                    class="w-[10px]"
                    v-html="plusIcon"
                ></span>
            </button>
        </div>
    </div>
</template>

<script setup>
    import { computed } from 'vue';

    import minusIcon from '@img/icons/minus.svg?raw';
    import plusIcon from '@img/icons/plus.svg?raw';

    const props = defineProps([
        'label',
        'name',
        'value',
    ]);

    // The prop as a number, whatever it arrived as. Not a fallback for bad data
    // so much as the only honest reading of it: "0" and 0 mean the same thing to
    // the person who typed it.
    const count = computed(() => Number(props.value) || 0);
</script>
